import React, { useEffect, useRef } from 'react'
import { select } from 'd3'

import { ValueBox, MainValueBox } from '../utils/ValueWrappers'
import DrillBit from '../utils/DrillBit'

interface SurgeSwabTypes extends BasicTypes {
    theme: string
}

export default ({
    casingShoe,
    uom,
    drillstringVelocity,
    lithology,
    uomVelocity,
    bitDepth,
    holeDepth,
    theme,
    hideHoleDepth
}: SurgeSwabTypes): JSX.Element => {
    const drillRef = useRef(null)
    const drillStringRef = useRef(null)

    useEffect(() => {
        select(drillRef?.current).attr('y', 0)

        if (drillRef?.current && drillStringRef?.current) {
            select(drillRef?.current)
                .transition()
                .duration(1000)
                .attr('y', '468')

            select(drillStringRef?.current)
                .transition()
                .duration(1000)
                .attr('y2', '468')
        }
    }, [drillRef?.current, drillStringRef?.current])

    return (
        <g
            style={{
                transform: lithology ? 'translateX(28px)' : 'translateX(0px)'
            }}
        >
            <line x1="17.86" x2="17.86" y1="0" y2="22" stroke="#C8CCD4" strokeWidth="35.72px" />
            <polygon points="0,22 4.36,15.59 4.36,0  31.36,0 31.36,15.59 35.72,22" fill="#252C38" />

            <line x1="17.86" x2="17.86" y1="0" y2="613" stroke="#868695" strokeWidth="19px" />
            <line
                ref={drillStringRef}
                className="drill-string"
                x1="17.86"
                x2="17.86"
                y1="0"
                y2="0"
                stroke="#252C38"
                strokeWidth="5px"
            />

            <DrillBit refDrill={drillRef} />

            <MainValueBox
                points="35.72,22 47.72,33 59,33"
                x="52"
                y="8"
                height="96"
                h2="CASING SHOE"
                h3_1="DEPTH"
                p_1={(casingShoe ? casingShoe.depth ?? '-' : '') + ' ' + (uom ?? '')}
                h3_2="ECD"
                p_2={(casingShoe ? casingShoe.ECD ?? '-' : '') + ' ppg'}
                theme={theme}
            />

            <ValueBox
                points="20.36,243 47.72,231 59,231"
                x="52"
                y="203"
                height="56"
                h2="DRILLSTRING VELOCITY"
                p={(drillstringVelocity ?? '-') + ' ' + (uomVelocity ?? '')}
                theme={theme}
                className="line-drill-string"
            />

            <ValueBox
                points="27.36,495 47.72,471 59,471"
                x="52"
                y="449"
                height="44"
                h2="BIT DEPTH"
                p={(bitDepth ?? '-') + ' ' + (uom ?? '')}
                theme={theme}
                className="line-bit-depth"
            />

            {!hideHoleDepth && <ValueBox
                points="27.36,613 47.72,591 59,591"
                x="52"
                y="569"
                height="44"
                h2="HOLE DEPTH"
                p={(holeDepth ?? '-') + ' ' + (uom ?? '')}
                theme={theme}
            />}
        </g>
    )
}
